module.exports = function Worker_fn() {
  return new Worker(__webpack_public_path__ + "clustering-gql.worker.03501d17d6d5ce0028f9.worker.js");
}
